
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "upgrade-plan-modal",
  setup() {
    const router = useRouter();
    const goToPlans = () => {
      setTimeout(() => {
        router.push({ name: "plans" });
      }, 250);
    };
    return {
      goToPlans,
    };
  },
});
